export default "__VITE_ASSET__VYIP49AL__"